import React from 'react';
import PropTypes from 'prop-types';
import Badge from 'componentsV2/Badge';
import { Link } from 'react-router';
import { noop } from 'helpers/GlobalHelper';
import { renderImage as renderDynamicImage, POSTER_IMAGE } from 'helpers/ImageHelper';
import { getBadgeLabel, NEW_EPISODE_BADGE, SHOW_STATE_FREE } from 'helpers/BadgeHelper';
import { urlIsExternal } from 'helpers/ContentHelper';

const SimplifiedImage = ({
  badge,
  breakpoint,
  image,
  item,
  onPosterClick,
  posterAltText,
  preventLazyLoad,
  route,
  theme,
}) => {
  const renderImage = image => {
    if (!image) return null;
    const dynamicImage = renderDynamicImage({
      alt: posterAltText,
      breakpoint,
      className: theme.carouselPosterImage,
      imageType: POSTER_IMAGE,
      preventLazyLoad,
      src: image,
    });
    let badgeLabel = getBadgeLabel(badge);
    if (badgeLabel === NEW_EPISODE_BADGE) badgeLabel = 'NEW';
    if (badge === SHOW_STATE_FREE) badgeLabel = 'FREE';
    if (route) {
      const redirect = urlIsExternal(route) ? { href: route } : { to: route };
      const ariaLabel = `${item.seriesName || item.name}, new`;
      return (
        <Link {...redirect} key={route} onClick={onPosterClick} aria-label={ariaLabel}>
          {dynamicImage}
          <Badge type={badgeLabel?.toLowerCase()} theme={theme} text={badgeLabel} />
        </Link>
      );
    }
    return dynamicImage;
  };
  const posterImage = renderImage(image);
  return <div className={theme.simplifiedHover}>{posterImage}</div>;
};

export default SimplifiedImage;

SimplifiedImage.defaultProps = {
  badge: null,
  breakpoint: null,
  image: null,
  item: {},
  onPosterClick: noop,
  posterAltText: '',
  preventLazyLoad: false,
  route: null,
};

SimplifiedImage.propTypes = {
  badge: PropTypes.string,
  breakpoint: PropTypes.string,
  image: PropTypes.string,
  item: PropTypes.shape({}),
  onPosterClick: PropTypes.func,
  posterAltText: PropTypes.string,
  preventLazyLoad: PropTypes.bool,
  route: PropTypes.string,
  theme: PropTypes.shape({}).isRequired,
};
